import { Dashboard, ExitToApp } from '@material-ui/icons';
// import headerImg from '../img/header.jpg'
import React from 'react';
import '../Component/Navigation.css'
import { Navbar, Nav } from 'react-bootstrap';
import {
    BrowserRouter as Router,

    Link
} from "react-router-dom";
// import Header from './Header';
import useAuth from './Login/useAuth';
const Navigation = () => {
    const { user, logOut } = useAuth()
    return (
        <div className='colorNavigation my-3'>

            {/* <Header></Header> */}
            <Navbar

                className='ms-5 ' expand="lg">

                <Navbar.Toggle aria-controls="basic-navbar-nav bg-dark ssss" />
                <Navbar.Collapse id="basic-navbar-nav bg-dark ">
                <h5 className='fw-normal font-monospace'>Mobile Shop</h5>
                    <Navbar.Collapse className="justify-content-around">

                        <Nav

                            className="mx-auto fw-lighter ">
                            <Link
                                className=' text-dark me-3 fw-lighter fs-5 text-dark text-decoration-none ' to='/home'>
                                Home</Link>
                         
                            {user.email ? <Link
                                className=' text-dark fw-lighter fs-5 text-dark text-decoration-none ' to='/user'>
                                Form</Link> :
                                <Link
                                    className=' text-dark fw-lighter fs-5 text-dark text-decoration-none ' to='/user'>
                                    AddUser</Link>
                            }
                            {user.email ? <Link className='fw-lighter mx-3 fs-5 text-dark text-decoration-none text-dark' to='/adduser'>
                                Profile</Link> : <Link className='fw-lighter mx-3 fs-5 text-dark text-decoration-none text-dark' to='/adduser'>
                                All User</Link>}


                            <Link
                                className=' me-lg-3 text-decoration-none fs-5 text-dark' to='/appointement'>
                                Shop</Link>
                        </Nav>

                    </Navbar.Collapse>
                    <div className='me-5'>
                        <Navbar.Text className=''>
                            <div className=" ">
                                <Link to='/deshbord'>
                                    <button className='btn btn-dark me-3 text-white '>
                                        <Dashboard></Dashboard>

                                        Deshbord</button>
                                </Link>
                                {
                                    user?.email ?

                                        <button className='btn btn-outline-success btn-sm me-1 text-dark' onClick={logOut}>
                                            <ExitToApp></ExitToApp>

                                            LogOut</button>


                                        : <Link className='text-dark text-decoration-none fs-5 text-dark' to='/login'>
                                            <ExitToApp></ExitToApp>

                                            Login</Link>
                                }

                               <Link to='/adduser'>
                               <a className='text-uppercase font-monospace text-dark'>
                                    {user?.displayName}
                                </a>
                               </Link>
                            </div>
                        </Navbar.Text>
                    </div>
                </Navbar.Collapse>

            </Navbar>
            <hr />

        </div>
    );
};

export default Navigation;

